import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import styled from "styled-components";

const NavigationContainer = styled.nav`
	position: relative;
	width: 80px;
	height: 100vh;
	display: flex;
	position: fixed;
	background: var(--color-surface);
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 12px;
	z-index: 6;
	-webkit-touch-callout: none;
	-webkit-user-select: none;
	-khtml-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;

	@media (max-width: 480px) {
		width: 100vw;
		height: 80px;
		bottom: 0;
		flex-direction: row;
	}
`;

const DestIndicator = styled.div`
	display: flex;
	width: 56px;
	height: 32px;
	justify-content: center;
	align-items: center;
	border-radius: 28px;
	background: var(
		${(props) =>
			props.isActive ? "--color-primary-container" : "--color-surface"}
	);
	color: var(
		${(props) =>
			props.isActive
				? "--color-on-primary-container"
				: "--color-on-surface"}
	);
	transition: 0.3s;
`;

const DestContainer = styled(Link)`
	display: flex;
	flex-direction: column;
	width: 100%;
	height: 56px;
	justify-content: center;
	align-items: center;
	text-align: center;
	gap: 4px;
	text-decoration: none !important;
	transition: 0.3s;

	&:hover ${DestIndicator} {
		background: var(--color-surface-variant);
	}
`;

const DestIcon = styled.span`
	display: block;
	width: 24px;
	height: 24px;
	font-size: 24px;
	line-height: 24px;
	font-family: "Material Symbols Rounded" !important;
	-webkit-touch-callout: none;
	-webkit-user-select: none;
	-khtml-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
	font-variation-settings: "FILL" ${(props) => (props.isActive ? "1" : "0")},
		"wght" 400, "GRAD" 0, "opsz" 24;
	transition: 0.3s;
`;

const DestLabel = styled.span`
	color: var(
		${(props) =>
			props.isActive
				? "--color-on-surface-variant"
				: "--color-on-surface"}
	);
	font-style: var(--md-sys-typescale-label-medium-font-family-style);
	font-weight: var(
		${(props) =>
			props.isActive
				? "--md-sys-typescale-label-medium-font-weight-prominent"
				: "--md-sys-typescale-label-medium-font-weight"}
	);
	font-size: var(--md-sys-typescale-label-medium-font-size);
	letter-spacing: var(--md-sys-typescale-label-medium-tracking);
	line-height: var(--md-sys-typescale-label-medium-height);
	text-transform: var(--md-sys-typescale-label-medium-text-transform);
	text-decoration: none;
	transition: 0.3s;
`;

function NavDesination({ title, src, isActive, desination }) {
	return (
		<DestContainer to={desination} isActive={isActive}>
			<DestIndicator isActive={isActive}>
				<DestIcon isActive={isActive}>{src}</DestIcon>
			</DestIndicator>
			<DestLabel isActive={isActive}>{title}</DestLabel>
		</DestContainer>
	);
}

export default function NavigationComponent() {
	const [index, setindex] = useState("");
	const location = useLocation();

	useEffect(() => {
		console.log(location.pathname);
		setindex(location.pathname);
	}, [location]);

	return (
		<NavigationContainer>
			<NavDesination
				title="Home"
				src="cottage"
				isActive={index === "/app"}
				desination="/app"
			/>
			<NavDesination
				title="Calendario"
				src="date_range"
				isActive={index === "/app/calendario"}
				desination="/app/calendario"
			/>
			<NavDesination
				title="Gestione"
				src="home_pin"
				isActive={index === "/app/gestione"}
				desination="/app/gestione"
			/>
			<NavDesination
				title="Tutorial"
				src="school"
				isActive={index.startsWith("/app/tutorial")}
				desination="/app/tutorial"
			/>
			<NavDesination
				title="Impostaz."
				src="settings"
				isActive={index === "/app/impostazioni"}
				desination="/app/impostazioni"
			/>
		</NavigationContainer>
	);
}
